<template>
    <RadioGroup v-model="reactiveValue" v-on="$listeners" class="dict-radio-group">
        <Radio v-for="(item, index) in dictList" :key="index" :label="item.value" :disabled="item.disabled || disabled" :border="border">{{ item.name }}</Radio>
    </RadioGroup>
</template>

<script>
import {isNotEmpty} from "@/utils/func";

export default {
    name: "DictRadioGroup",
    props: {
        dict: {
            type: String
        },
        isSearch: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Boolean],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        border: {
            type: Boolean,
            default: false,
        },
        useAllType: {
            type: Boolean,
            default: false,
        },
        // 字典过滤
        filterMethod: {
            type: Function,
            default: null,
        }
    },
    computed: {
        dictList() {
            if (this.dict === 'switch') return [{value: '1', name: '是'}, {value: '0', name: '否'}];
            if (isNotEmpty(this.dict)) {
                let list = this.$comon.$dict(this.dict) || [];
                if (this.useAllType) {
                    list = [
                        {name: '全部', value: '-1'},
                        ...list
                    ];
                }
                if (this.filterMethod instanceof Function) {
                    list = this.filterMethod(list);
                }
                return list;
            }
            return [];
        },
        reactiveValue: {
            set(val) {
                this.$emit('input', val);
            },
            get() {
                return this.value;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.dict-radio-group {
    /deep/ .ivu-radio-border {
        padding-left: 3px;
        padding-right: 10px;

        .ivu-radio-inner {
            display: none;
        }
    }
}
</style>
